var map = {
	"./anime4player.jpeg": 3050,
	"./bearseasaw.png": 2348,
	"./bigfish.jpeg": 5277,
	"./boxer.png": 2418,
	"./boxerkick.png": 7976,
	"./coins.png": 5726,
	"./crazykitten.jpeg": 9079,
	"./fastfood.png": 1744,
	"./firewall.jpeg": 7115,
	"./joyplayer.png": 7289,
	"./junglehockey.png": 9970,
	"./jungleparty.jpeg": 6778,
	"./minibus.jpeg": 2866,
	"./minisub.jpeg": 2142,
	"./mukocut.jpeg": 2465,
	"./oceanparty.jpeg": 7957,
	"./pipicar.jpeg": 6699,
	"./pirateship.png": 395,
	"./rainbowhoops.jpeg": 7766,
	"./sharkpark.jpeg": 9364,
	"./soccerstars.png": 1440,
	"./solarstorm.png": 4540,
	"./tide.png": 8766,
	"./tideplayer.png": 689,
	"./topgun2.png": 6617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8381;